import svg4everybody from 'svg4everybody';
import debugInfo from './helpers/_debugInfo';
import detectIE from './helpers/_detectIE';
import { detectTouch, updateViewportUnits } from "./helpers/_global"
import Header from "./components/header"
import Modal from './components/Modal';
import reviewsSlider from './sliders/_reviews';


// include temp scripts
import tempInit from './temp/common';


$(document).ready(() => {
  debugInfo();
  detectTouch();
  updateViewportUnits();

  const pageHeader = new Header();
  pageHeader.init();

  const cmpModal = new Modal();
  cmpModal.init();

  const version = detectIE();
  if (version !== false) $('html').addClass('ie');

  svg4everybody();

  reviewsSlider();

  // init temp scripts
  tempInit();


});
